import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { CHILDREN_PROPTYPES } from 'base/constants/propTypes';
import SecondaryCta from 'base/components/SecondaryCta';
import { WHITE } from 'base/constants/colors';

const styles = theme => ({
  root: {
    color: WHITE,
    textAlign: 'center'
  }
});

const HeroSecondaryCta = ({ handleClick, label, classes, dataTestId }) => {
  return (
    <SecondaryCta
      label={label}
      dataTestId={dataTestId}
      handleClick={handleClick}
      classes={classes}
      fullWidth
    />
  );
};

HeroSecondaryCta.propTypes = {
  handleClick: PropTypes.func,
  label: CHILDREN_PROPTYPES,
  classes: PropTypes.shape({}),
  dataTestId: PropTypes.string
};

export default withStyles(styles)(HeroSecondaryCta);
